import { useState } from "react";
import {BuyAndSellOrdersSvg, BuyOrdersSvg, MOBILE_SIZE, SellOrdersSvg} from "../../constants/common";
import { FlexStart, SvgWrapper, Padding, FlexCenter, DText, FlexEnd } from "../../styles/CommonStyles";
import Text from "../../utils/Text";
import { OrdersBox } from "../../styles/BoxingStyles"
import AllOrders from "./AllOrders";
import TypeOrders from "./TypeOrders";
import { OrdersHeader } from "../../styles/OrderBookStyles"
import {useWindowSize} from "../../hooks/common/useWindowSize";


const OrdersBook = () => {

    const { width } = useWindowSize()
    const [activeTab, setActiveTab] = useState(0)

    return (
        <OrdersBox>
            <OrdersHeader>
                {/* tabs */}
                <FlexStart>
                    {svgs.map((svg, idx) => (
                        <SvgWrapper
                            key={idx}
                            active={activeTab === idx}
                            onClick={() => setActiveTab(idx)}
                        >
                            {svg}
                        </SvgWrapper>
                    ))}
                </FlexStart>

                {/* headers */}
                <FlexCenter>
                    <Padding padding="10px 0">
                        {(width > MOBILE_SIZE ? headers : headers.slice(0, 2))
                            .map((header, idx) => (
                                idx === 0 ?
                                    <FlexStart key={header} width={width > MOBILE_SIZE ? "30%" : "70%"}>
                                        <DText id={`order-book-${header}`} fontSize=".7rem"><Text tid={header} /></DText>
                                    </FlexStart>
                                    :
                                    <FlexEnd key={header} width={idx === 1 ? "30%" : "40%"}>
                                        <DText id={`order-book-${header}`} fontSize=".7rem"><Text tid={header} /></DText>
                                    </FlexEnd>
                        ))}
                    </Padding>
                </FlexCenter>
            </OrdersHeader>

            {/* allOrders */}
            {activeTab === 0 &&
                <AllOrders />
            }

            {/* buyOrders */}
            {activeTab === 1 &&
                <TypeOrders type="buy" />
            }

            {/* sellOrders */}
            {activeTab === 2 &&
                <TypeOrders />
            }

        </OrdersBox>
    )
}


const headers = [
    "price", "amount", "total"
]

const svgs = [
    <BuyAndSellOrdersSvg />, <BuyOrdersSvg />, <SellOrdersSvg />
]

export default OrdersBook;
